import { message } from "antd";
import { makeApiRequest } from "./apiBody"
import { formatDate } from "utils/helpers";
import { format } from "date-fns";
import moment from "moment";

async function createAppointmentRequest(values) {
  try {
    const appointmentData = {
      appointmentDate: values.date, 
      appointmentTime: values.appointmentTime, // Store as ISO UTC string
      message: values.description,
      title: values.title,
      clientDetails: {
        name: values.name,
        email: values.email,
        phone: values.phone
      }
    };

    // 6. Make API request
    const response = await makeApiRequest({
      serviceName: 'underwriting',
      resourceName: 'appointment',
      actionName: 'intermediaryAppointmentRequest',
      data: appointmentData,
    });

    return response;

  } catch (err) {
    console.error("Error in createAppointmentRequest:", err);
    throw err; // Let caller handle
  }
}

async function listAppointmentsCreatedForIntermediary(values) {
  try {
    const data = {
        "querryOptions": {
            "page": values.page
        }
    }
    
    const response = makeApiRequest({
      serviceName: 'underwriting',
      resourceName: 'appointment',
      actionName: 'listAppointmentsCreatedForIntermediary',
      data
    });

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}


async function listAppointmentsCreatedForClient(values) {
  try {
    const data = {
        "querryOptions": {
            "page": values.page
        }
    }

    const response = await makeApiRequest({
      serviceName: 'underwriting',
      resourceName: 'appointment',
      actionName: 'listAppointmentsCreatedForClient',
      data
    });

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}

async function getAppointmentCreatedForIntermediary(appointmentSystemRef) {
  try {
    const data = {
      appointmentSystemRef
    };

    const response = await makeApiRequest({
      serviceName: 'underwriting',
      resourceName: 'appointment',
      actionName: 'getAppointmentRequest',
      data,
    });

    console.log("APPDETAILS", response)

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}

async function acceptAppointmentRequest(appointmentSystemRef) {
  try {
    const data = {
      appointmentSystemRef
    };

    console.log("appointref", data)
    const response = await makeApiRequest({
      serviceName: 'underwriting',
      resourceName: 'appointment',
      actionName: 'acceptAppointmentRequest',
      data,
    });

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}

async function rejectAppointmentRequest(appointmentSystemRef, rejectionRemarks=" ") {
  try {
    const data = {
      appointmentSystemRef,
      rejectionRemarks
    };
    
    const response = await makeApiRequest({
      serviceName: 'underwriting',
      resourceName: 'appointment',
      actionName: 'intermediaryRejectionAppointmentRequest',
      data,
    });

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}



async function listAppointments(values) {
  try {
    const data = {
        "querryOptions": {
            "page": values.page
        }
    }

    const response = await makeApiRequest({
      serviceName: 'underwriting',
      resourceName: 'appointment',
      actionName: 'listIntermediaryAppointments',
      data,
    });

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}



export {
    createAppointmentRequest,
    listAppointmentsCreatedForIntermediary,
    listAppointmentsCreatedForClient,
    getAppointmentCreatedForIntermediary,
    acceptAppointmentRequest,
    rejectAppointmentRequest,
    listAppointments,
}

